const AUTH_STORAGE_KEYS = [
  "accessToken",
  "refreshToken",
  "isLogged",
  "userEmail",
  "userRole",
  "userId",
  "firstname",
  "lastname",
  "phone",
  "name",
  "agency",
  "agencyId",
  "agencyName",
  "agencyCity",
];

const getStorage = (name) => {
  try {
    return typeof window !== "undefined" ? window[name] : null;
  } catch {
    return null;
  }
};

const readStoredValue = (key) => {
  try {
    return getStorage("localStorage")?.getItem(key) || null;
  } catch {
    return null;
  }
};

export const readAuthenticationState = () => ({
  accessToken: readStoredValue("accessToken"),
  refreshToken: readStoredValue("refreshToken"),
  isLogged: readStoredValue("isLogged") === "true",
  userId: readStoredValue("userId"),
  userEmail: readStoredValue("userEmail"),
});

export const authenticationFingerprint = (
  state = readAuthenticationState(),
) => {
  if (state.accessToken) return `access:${state.accessToken}`;
  if (state.refreshToken) return `refresh:${state.refreshToken}`;
  if (state.isLogged) {
    return `session:${state.userId || state.userEmail || "unknown"}`;
  }
  return null;
};

export const clearAuthenticationStorage = () => {
  ["localStorage", "sessionStorage"].forEach((storageName) => {
    const storage = getStorage(storageName);
    if (!storage) return;

    AUTH_STORAGE_KEYS.forEach((key) => {
      try {
        storage.removeItem(key);
      } catch {
        // Un stockage indisponible ne doit pas empêcher la déconnexion.
      }
    });
  });
};

const SAFE_URL_BASE = "https://jm-interim.local";

export const isSafeInternalPath = (path) => {
  if (
    typeof path !== "string" ||
    !path.startsWith("/") ||
    path.startsWith("//") ||
    /[\r\n]/.test(path)
  ) {
    return false;
  }

  try {
    const parsed = new URL(path, SAFE_URL_BASE);
    return (
      parsed.origin === SAFE_URL_BASE &&
      !/^\/login(?:\/|$)/i.test(parsed.pathname)
    );
  } catch {
    return false;
  }
};

export const buildLoginRedirectUrl = (
  location = typeof window !== "undefined" ? window.location : null,
) => {
  if (!location) return "/login";

  const returnTo = `${location.pathname || "/"}${location.search || ""}${
    location.hash || ""
  }`;

  return isSafeInternalPath(returnTo)
    ? `/login?returnTo=${encodeURIComponent(returnTo)}`
    : "/login";
};

export const getPostLoginPath = (search, fallback = "/dashboard") => {
  try {
    const returnTo = new URLSearchParams(search || "").get("returnTo");
    return isSafeInternalPath(returnTo) ? returnTo : fallback;
  } catch {
    return fallback;
  }
};

export const redirectToLogin = (url = buildLoginRedirectUrl()) => {
  if (typeof window !== "undefined") window.location.replace(url);
};
